<template>
  <div>
    <form action="">
      <v-card class="mb-6" v-for="(card, index) in cards" :key="index">
        <v-toolbar dense elevation="0">
          <v-toolbar-title class="subtitle-1">{{
            card.titleCard
          }}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-row
          class="align-center pl-4 pr-4"
          v-for="(row, indexRow) in card.rows"
          :key="indexRow"
        >
          <v-col cols="12 pb-0">
            <div class="d-flex overline justify-start align-center">
              <div class="grey--text">
                {{ row.titleRow }}
              </div>
              <v-divider class="ml-4"></v-divider>
            </div>
          </v-col>

          <v-col
            v-for="(col, indexCol) in row.cols"
            :key="indexCol"
            :cols="getCols(row.cols)"
          >
            <v-form v-model="form">
              <div>
                <div class="pb-2 subtitle-2">
                  {{ col.label }}
                  <v-tooltip top v-if="col.tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-on="on" v-bind="attrs" color="primary" small>
                        mdi-information
                      </v-icon>
                    </template>
                    {{ col.tooltip }}
                  </v-tooltip>
                </div>
                <v-text-field
                  v-if="col.field.type == 'text'"
                  :type="col.field.typeFiled"
                  v-model="col.field.model"
                  :disabled="col.field.disabled"
                  @blur="getApiCEP(col.field.name, col.field.model)"
                  :name="col.field.name"
                  :append-icon="col.field.icon"
                  solo-inverted
                  required
                  :rules="col.field.rules ? col.field.rules : []"
                  dense
                  hide-details="auto"
                  class="subtitle-2"
                ></v-text-field>

                <v-select
                  v-model="col.field.model"
                  v-if="col.field.type == 'select'"
                  :items="col.field.items"
                  item-text="nome"
                  item-value="id"
                  :label="$t('toSelect')"
                  solo-inverted
                  dense
                  hide-details
                  class="subtitle-2"
                ></v-select>

                <v-textarea
                  v-if="col.field.type == 'textarea'"
                  v-model="col.field.model"
                  class="pre-formatted subtitle-2"
                  :name="col.field.name"
                  height="150"
                  no-resize
                  solo
                  light
                ></v-textarea>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="d-flex justify-end">
        <div class="pa-4">
          <v-btn
            small
            class="ml-2 white black--text"
            @click="getInstitutional"
            >{{ $t("toCancel") }}</v-btn
          >
          <v-btn
            small
            class="ml-2 info"
            @click="submit"
            :disabled="!form || loading"
          >
            {{ $t("toSave") }}
          </v-btn>
        </div>
      </v-card>
    </form>
  </div>
</template>

<script>
import { validate } from "@/util/validate";

export default {
  name: "",
  data: () => ({
    models: [],
    cards: [],
    form: false,
    loading: false,
    emailRules: [validate.notEmpty, validate.required, validate.validEmail],
  }),
  computed: {
    card() {
      return [
        {
          titleCard: this.$t("institutional"),
          rows: [
            {
              titleRow: this.$t("workWithusAndContact"),
              cols: [
                {
                  label: this.$t("publicContactEmail"),
                  tooltip: this.$t("billingEmailTooltip"),
                  field: {
                    name: "email",
                    model: "",
                    type: "text",
                    typeFiled: "email",
                    icon: "mdi-email-outline",
                    rules: this.emailRules,
                  },
                },
              ],
            },
            {
              titleRow: this.$t("socialNetWorks"),
              cols: [
                {
                  label: "Whatsapp",
                  field: {
                    name: "phone",
                    model: "",
                    icon: "mdi-whatsapp",
                    type: "text",
                  },
                },
                {
                  label: "Instagram",
                  field: {
                    name: "instagram",
                    model: "",
                    icon: "mdi-instagram",
                    type: "text",
                  },
                },
                {
                  label: "Facebook",
                  field: {
                    name: "facebook",
                    model: "",
                    icon: "mdi-facebook",
                    type: "text",
                  },
                },
              ],
            },
            {
              titleRow: "Tags",
              cols: [
                {
                  label: "Google Tag Manager",
                  field: {
                    name: "tag_gtm",
                    model: "",
                    icon: "mdi-google",
                    type: "text",
                  },
                },
              ],
            },
            {
              titleRow: this.$t("aboutYourCompany"),
              cols: [
                {
                  label: this.$t("tellAboutYourBusiness"),
                  field: {
                    name: "about",
                    model: "",
                    type: "textarea",
                    icon: "",
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("registrationDataBilling"),
          rows: [
            {
              titleRow: this.$t("dataResponsible"),
              cols: [
                {
                  label: "CPF",
                  tooltip: this.$t("cpfTooltip"),
                  field: {
                    name: "document_id",
                    model: "",
                    type: "text",
                    typeFiled: "text",
                    icon: "",
                    disabled: true,
                  },
                },
                {
                  label: this.$t("billingEmail"),
                  field: {
                    name: "email_invoice",
                    model: "",
                    type: "text",
                    typeFiled: "email",
                    icon: "",
                  },
                },
              ],
            },
            {
              titleRow: this.$t("dataAddress"),
              cols: [
                {
                  label: "CEP",
                  field: {
                    name: "zip_code",
                    model: "",
                    type: "text",
                    typeFiled: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("address"),
                  field: {
                    name: "address",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("number"),
                  field: {
                    name: "number",
                    model: "",
                    type: "text",
                    typeFiled: "number",
                    icon: "",
                  },
                },
                {
                  label: this.$t("neighborhood"),
                  field: {
                    name: "district",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("state"),
                  field: {
                    name: "id_state",
                    model: "",
                    items: [],
                    type: "select",
                    icon: "",
                  },
                },
                {
                  label: this.$t("city"),
                  field: {
                    name: "id_city",
                    model: "",
                    items: [],
                    type: "select",
                    icon: "",
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("generalSettings"),
          rows: [
            {
              titleRow: this.$t("promotions"),
              cols: [
                {
                  label: this.$t("informPromotionsByYourBusiness"),
                  field: {
                    name: "promotion",
                    model: "",
                    type: "textarea",
                    icon: "",
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },

  created() {
    this.getInstitutional();
    this.cards = this.card;
  },

  methods: {
    async getInstitutional() {
      this.loading = true;

      const request = await this.$request.get(
        "/administrator/account/getInstitutional"
      );
      this.getApiCEP("zip_code", request.dados.zip_code);
      for (let card of this.cards) {
        for (let row of card.rows) {
          for (let col of row.cols) {
            col.field.model = request.dados[col.field.name] || " ";
            if (col.field.name === "email" && col.field.model === " ") {
              this.form = false;
            }
          }
        }
      }

      this.loading = false;
    },

    // GET CEP
    async getApiCEP(name, cep) {
      if (name != "zip_code") return;

      const address = this.cards[1].rows[1].cols[1];
      const neighborhood = this.cards[1].rows[1].cols[3];

      const request = await this.$request.post("player/register/fetchCep", {
        cep,
      });
      const { uf, cidade, logradouro, bairro } = await request.dados;

      address.field.model = logradouro;
      neighborhood.field.model = bairro;

      this.getStates(uf, cidade);
    },

    // GET STATES
    async getStates(uf, city) {
      const states = this.cards[1].rows[1].cols[4];
      const request = await this.$request.get("player/register/fetchStates");
      states.field.items = request.dados;
      states.field.model = request.dados.filter((item) => item.uf == uf)[0].id;
      this.getCity(states.field.model, city);
    },

    // GET CITY
    async getCity(id_state, cityName) {
      const city = this.cards[1].rows[1].cols[5];
      const request = await this.$request.post("player/register/fetchCities", {
        id_state,
      });
      city.field.items = request.dados;
      city.field.model = request.dados.filter(
        (item) => item.nome == cityName
      )[0].id;
    },

    getCols(cols) {
      if (this.$vuetify.breakpoint.lg)
        return cols.length >= 4 ? 6 : 12 / cols.length;
      if (this.$vuetify.breakpoint.md)
        return cols.length >= 4 ? 6 : 12 / cols.length;
      if (this.$vuetify.breakpoint.sm)
        return cols.length >= 4 ? 6 : 12 / cols.length;
      if (this.$vuetify.breakpoint.xs) return 12;
    },

    // Submit
    async submit() {
      const body = {};
      const data = this.cards
        .map((item) => item.rows)
        .reduce((a, b) => [...a, ...b])
        .map((item) => item.cols)
        .reduce((a, b) => [...a, ...b]);

      for (let item of data) {
        body[item.field.name] = item.field.model;
      }

      const postData = await this.$request.post(
        "/administrator/account/editInstitutional",
        body
      );
      if (postData.length == 0) return;
      this.$store.commit("setFeedbackSnack", {
        msg: postData.messages,
        color: "success",
      });
    },
  },
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
